<!-- 学校-教师评价统计 -->
<template>
  <div>
    <div class="index" v-show="!detail.show">
      <div class="title">
        <div class="span1">
          <span>{{ $route.name }}</span>
        </div>
      </div>
      <!-- 图形 -->
      <!-- <div
        class="hygrometer"
        style="width: 250px; height: 250px"
        ref="hygrometer"
      ></div> -->
      <header>
        <div class="header-item">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>评价进度</span>
          </div>
          <div class="progress progress-blue">
            <el-progress type="circle" :percentage="86"></el-progress>
            <div class="progress-text">
              <p class="bfb">
                <span class="bfb-text">{{86}}</span><span>%</span>
              </p>
              <p>评价完成率</p>
            </div>
          </div>
        </div>

        <div class="header-item">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>综合评价分</span>
          </div>
          <div class="progress progress-green">
            <el-progress type="circle" :percentage="86" status="success"></el-progress>
            <div class="progress-text">
              <p class="bfb">
                <span class="bfb-text" style="color:#09A77C">{{86}}</span>
              </p>
              <p>综合评价分</p>
            </div>
          </div>
        </div>

        <div class="header-item">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>评价TOP5教师</span>
          </div>
          <ul>
            <li v-for="(item,index) in userList" :key="item.user_id+index">
              <img class="sort" :src="userSort[index]" alt="" v-if="index<3">
              <div class="sort" v-if="index>=3">{{index+1}}</div>
              <p>{{item.name}}</p>
              <span>{{item.num}}</span>
            </li>
          </ul>
        </div>
      </header>
      
      <div>
        <el-form :inline="true" :model="queryParams" label-width="70px">
          <el-form-item label="">
            <el-date-picker
              v-model="queryParams.date"
              :picker-options="pickerOptions"
              style="width: 265px"
              type="week"
              :format="
                queryParams.startDate + '~' + queryParams.endDate + '第 WW 周'
              "
              placeholder="选择周"
              @change="customTimeSure"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="" style="width:180px">
            <el-input
              v-model="queryParams.name"
              placeholder="请输入评价名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="" style="width:180px">
            <el-select
              v-model="queryParams.cycle_1"
              clearable
              placeholder="选择评价周期"
              class="label"
            >
              <el-option
                v-for="item in cycleList_1"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" style="width:180px">
            <el-select
              v-model="queryParams.cycle_2"
              clearable
              placeholder="选择周期"
              class="label"
            >
              <el-option
                v-for="item in cycleList_2"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" style="margin-left: 20px">
            <el-button type="primary" size="small" @click="searchFun()"
              >搜索</el-button
            >
          </el-form-item>
        </el-form>

        <!-- 校内教师 -->
        <div class="table">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="evaluationName" label="评价名称" align="center">
            </el-table-column>
            <el-table-column
              prop="cycle"
              label="评价周期"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="name" label="教师姓名" align="center">
            </el-table-column>
            <el-table-column
              prop="source"
              label="教师来源"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="time" label="可评价时间" align="center">
            </el-table-column>
            <el-table-column
              prop="state"
              label="评价完成情况"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="score"
              label="评价得分"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="dimension"
              label="评价 维度"
              align="center"
            >
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              background
              :current-page="pageNum"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              :total="totalPage"
              layout="total,prev, pager, next,jumper,sizes"
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api/wisdomSchool/index.js";
import dayjs from "dayjs";
import * as echarts from "echarts";
import "echarts-liquidfill";
export default {
  components: {},
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      totalPage: 0,
      queryParams: {
        cycle_1: "",
        cycle_2: "",
        name: "",
        date: "",
        startDate: "",
        endDate: "",
      },
      cycleList_1: [
        {id:'xqp',label:'学期评'},
        {id:'yp',label:'月评'},
        {id:'zp',label:'周评'},
      ],
      cycleList_2: [],
      tableData: [
        {evaluationName:'11月课后服务之星',cycle:'月评/11月',name:'谢科',source:'本校',time:'2021-11-11 ~ 2021-11-30',state:'已完成',score:90,dimension:'教师互评 学生评 家长评'},
        {evaluationName:'11月课后服务之星',cycle:'月评/11月',name:'陈正清',source:'本校',time:'2021-11-11 ~ 2021-11-30',state:'已完成',score:90,dimension:'教师互评 学生评 家长评'},
        {evaluationName:'11月课后服务之星',cycle:'月评/11月',name:'李必先',source:'本校',time:'2021-11-11 ~ 2021-11-30',state:'已完成',score:90,dimension:'教师互评 学生评 家长评'},
        {evaluationName:'12月课后服务之星',cycle:'月评/11月',name:'朱政廷',source:'欧美思',time:'2021-11-11 ~ 2021-11-30',state:'已完成',score:90,dimension:'教师互评 学生评 家长评'},
        {evaluationName:'11月课后服务之星',cycle:'月评/11月',name:'邓诗涵',source:'欧美思',time:'2021-11-11 ~ 2021-11-30',state:'已完成',score:90,dimension:'教师互评 学生评 家长评'},
        {evaluationName:'12月课后服务之星',cycle:'月评/11月',name:'林佩玲',source:'欧美思',time:'2021-11-11 ~ 2021-11-30',state:'已完成',score:90,dimension:'教师互评 学生评 家长评'},
        {evaluationName:'11月课后服务之星',cycle:'月评/11月',name:'谢文华',source:'欧美思',time:'2021-11-11 ~ 2021-11-30',state:'已完成',score:90,dimension:'教师互评 学生评 家长评'},
        {evaluationName:'12月课后服务之星',cycle:'月评/11月',name:'吴俊伯',source:'欧美思',time:'2021-11-11 ~ 2021-11-30',state:'已完成',score:90,dimension:'教师互评 学生评 家长评'},
        {evaluationName:'11月课后服务之星',cycle:'月评/11月',name:'李必先',source:'欧美思',time:'2021-11-11 ~ 2021-11-30',state:'已完成',score:90,dimension:'教师互评 学生评 家长评'},
      ],
      detail: {
        info: {},
        show: false,
      },
      school_info: JSON.parse(sessionStorage.getItem("classList")),
      semesterArr: JSON.parse(sessionStorage.getItem("semesterList")) || [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      userList:[
        {name:'谢科（本校）',user_id:'123112',num:97},
        {name:'陈正清（本校）',user_id:'128882',num:96},
        {name:'李必先（本校）',user_id:'125552',num:94},
        {name:'朱政廷（欧美思）',user_id:'127772',num:94},
        {name:'邓诗涵（欧美思）',user_id:'1266612',num:93},
      ],
      userSort:[
        require('@/assets/img/statistical/one.svg'),require('@/assets/img/statistical/two.svg'),require('@/assets/img/statistical/three.svg')
      ]
    };
  },
  watch: {
    "queryParams.cycle_1": function (n, o) {
      this.queryParams.cycle_2 = "";
      if(n==='xqp'){
        this.cycleList_2 = [
          {id:'xqp1',label:'2021~2022年度下学期'},
          {id:'xqp2',label:'2021~2022年度上学期'},
          {id:'xqp3',label:'2020~2021年度下学期'},
          {id:'xqp4',label:'2020~2021年度上学期'},
          {id:'xqp5',label:'2019~2020年度下学期'},
          {id:'xqp6',label:'2019~2020年度上学期'},
        ];
      }else if(n==='yp'){
        this.cycleList_2 = [
          {id:'yp1',label:'11月'},
          {id:'yp2',label:'10月'},
          {id:'yp3',label:'09月'},
          {id:'yp4',label:'08月'},
          {id:'yp5',label:'07月'},
          {id:'yp6',label:'06月'},
        ];
      }else{
        this.cycleList_2 = [
          {id:'zp1',label:'第10周'},
          {id:'zp2',label:'第9周'},
          {id:'zp3',label:'第8周'},
          {id:'zp4',label:'第9周'},
          {id:'zp5',label:'第7周'},
          {id:'zp6',label:'第6周'},
        ];
      }
      
      // this.gradeList = this.campusList.filter((v) => v.id === n)[0]?.children || [];
    },
  },
  created() {
    // this.campusList = this.school_info?.slice() || [];
  },
  methods: {
    async getDataList() {
      let start = "",
        end = "";
      if (this.queryParams.date) {
        start = this.queryParams.startDate;
        end = this.queryParams.endDate;
      }
      let params = {
        schoolYearSemester: this.queryParams.semester,
        startDate: start,
        endDate: end,
        campusId: this.queryParams.cycle_1,
        gradeId: this.queryParams.cycle_2,
        orgId: sessionStorage.getItem("orgId"),
        platformCode: sessionStorage.getItem("platformCode"),
        page: this.pageNum,
        limit: this.pageSize,
      };

      // let res = await api.classAttendanceStatistics_1(params);
      // console.log('学生考勤列表',res)
      // if (res.code === "0") {
      //   this.tableData = res.data.list;
      //   this.totalPage = res.data.total || 0;
      // }
    },
    searchFun() {
      this.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageNum = val;
      this.getDataList();
    },
    toDetail(item) {
      this.detail.info = item;
      this.detail.show = true;
    },
    toIndex() {
      this.detail.show = false;
    },
    // 自定义时间过滤
    customTimeSure() {
      let that = this.queryParams;
      if (that.date) {
        that.startDate = dayjs(that.date).startOf("week").format("YYYY-MM-DD");
        that.endDate = dayjs(that.date).endOf("week").format("YYYY-MM-DD");
      }
    },
    setLiquidfill() {
      const hygrometer = echarts.init(this.$refs.hygrometer);
      const option = {
        series: [
          {
            type: "liquidFill",
            data: [0.45],
            outline: {
              show: true,
              borderDistance: 0,
              itemStyle: {
                borderWidth: 1,
                borderColor: "#ccc",
                shadowColor: 1,
              },
            },
            tooltip: {
              show: true,
            },
            color: ["#77A2F9", "#77A2F9", "#fff"],
            itemStyle: {
              opacity: 1, // 波浪的透明度
              shadowBlur: 0, // 波浪的阴影范围
              shadowColor: "#77A2F9", // 阴影颜色
            },
            label: {
              normal: {
                formatter(param) {
                  return `评价完成率\n${param.value * 100}%`;
                },
                textStyle: {
                  color: "#aaaaaa", // 波浪上文本颜色
                  insideColor: "#000000", // 波浪内部字体颜色
                  fontSize: 16,
                },
              },
            },
            emphasis: {
              itemStyle: {
                opacity: 1,
              },
            },

            backgroundStyle: {
              borderWidth: 0,
              borderColor: "#fff",
              color: "#fff",
            },
          },
        ],
      };
      hygrometer.setOption(option);
    },
  },
  mounted() {
    if(this.semesterArr && this.semesterArr.length>0){
      this.semesterList = this.semesterArr.map((v) => ({
        label: v.schoolYear + "第" + v.semester + "学期",
        id: v.schoolYear + "_" + v.semester,
      }));
    }
    this.getDataList();
  },
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .title {
    height: 60px;
    line-height: 48px;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-start;
    .span1 {
      font-family: "PingFang SC Bold";
      font-weight: bold;
      font-size: 20px;
      text-align: left;
      color: #000;
      margin-right: 30px;
    }
  }

  ::v-deep .el-form .el-input__inner {
    // width: 150px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}

header{
  width: 100%;
  height: 350px;
  display: flex;
  .header-item{
    width: 33%;
    .header-item-title{
      font-size: 18px;
      color: #333;
      display: flex;
      align-items: center;
      .circle{
        width: 8px;
        height: 8px;
        display: inline-block;
        background: #4991e1;
        border-radius: 50%;
        margin-right: 10px;
      }
    }
    .progress{
      margin: 80px 50px;
      position: relative;
      ::v-deep .el-progress-circle{
        width: 142px !important;
        height: 142px !important;
      }
      ::v-deep .el-progress__text{
        display: none;
      }
      .progress-text{
        position: absolute;
        top: 47px;
        left: 37px;
        text-align: center;
        .bfb{
          font-weight: bold;
          font-size: 20px;
          line-height: 24px;
          color: #4991e1;
          .bfb-text{
            font-size: 36px;
          }
        }
      }
    }
    .progress-blue ::v-deep .el-progress-circle__track {
      stroke: #9FCCFF;
      stroke-width:3;
    }
    .progress-blue ::v-deep .el-progress-circle__path {
      stroke: #1D83FC;
    }
    .progress-green ::v-deep .el-progress-circle__track {
      stroke: #C7F0E4;
      stroke-width:3;
    }
    .progress-green ::v-deep .el-progress-circle__path {
      stroke: #09A77C;
    }

    ul{
      width: 100%;
      height: 100%;
      li{
        width: calc(100% - 10px);
        height: 50px;
        border-radius: 4px;
        border: 1px solid #e2e2e2;
        box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.04);
        margin-top: 10px;
        display: flex;
        align-items: center;
        .sort{
          width: 20px;
          height: 20px;
          margin-left: 20px;
          text-align: center;
        }
        p{
          margin-left: 20px;
          width: 135px;
          line-height: 20px;
        }
        span{
          margin-left: 45px;
        }
      }
    }
  }
}
</style>
